module.exports = __webpack_public_path__ + "img/bo.7844f1e3.png";